import useResizeObserver from "use-resize-observer/polyfilled";

export default useResizeObserver;
